import { Component, Inject } from "@angular/core";
import { AngularFireAnalytics } from "@angular/fire/compat/analytics";
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from "@angular/material/bottom-sheet";
import { MatDialog } from "@angular/material/dialog";
import { OffersForYouElement } from "@interfaces/offersForYou.i";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { WinMorePromisePopupComponent } from "../win-more-promise-popup/win-more-promise-popup.component";
import { Data } from "@angular/router";
import { IonicModule } from "@ionic/angular";
@Component({
    selector: "app-win-more-popup",
    templateUrl: "./win-more-popup.component.html",
    styleUrls: ["./win-more-popup.component.scss"],
    standalone: true,
    imports: [IonicModule, TranslatePipe],
})
export class WinMorePopupComponent {
  private selectedTicket: Data; // selectedTicket_details
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public offersForYouElement: OffersForYouElement,
    private analytics: AngularFireAnalytics,
    private bottomSheetRef: MatBottomSheetRef<WinMorePopupComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: Data,
    public translate: TranslateService,
    private matDialog: MatDialog
  ) {
    // Get selectedTicket data from the MAT_BOTTOM_SHEET
    this.selectedTicket = data;
  }
  showPromisePopup() {
    this.matDialog.open(WinMorePromisePopupComponent, {
      panelClass: "win-Promise-popup",
      data: this.selectedTicket, // passed selectedTicket Parameters
    });
    this.bottomSheetRef.dismiss(); //close the popup
  }
  back() {
    this.bottomSheetRef.dismiss();
  }
}

